var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loading
    ? _c("div", { staticClass: "loading_wrap" }, [
        _vm._m(0),
        _c("div", { staticClass: "loading_content" }, [
          _vm._v(_vm._s(_vm.loading_content)),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "loading_container" }, [
      _c("div", { staticClass: "circle" }),
      _c("div", { staticClass: "circle" }),
      _c("div", { staticClass: "circle" }),
      _c("div", { staticClass: "shadow" }),
      _c("div", { staticClass: "shadow" }),
      _c("div", { staticClass: "shadow" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }